import { IAutoSave } from '../../IAutoSave';
import { IAutoSaveAction } from './IAutoSaveAction';
import { AbstractControl } from '@angular/forms/src/model';

export function updateModelType<TParentModel, TModel>(
  module: string,
  parentType: { new(): TParentModel; },
  type: { new(): TModel; } | string): string
{
  if (typeof type === 'string') {
    return `[${module}] Update ${(parentType as any).$typeName} ${type}`;
  }
  return `[${module}] Update ${(parentType as any).$typeName} ${(type as any).$typeName}`;
}

export class UpdateModelAction<TParentModel, TModel> implements IAutoSaveAction {
  readonly type: string;

  constructor(
    module: string,
    parentType: { new(): TParentModel; },
    modelType: { new(): TModel; } | string,
    public payload: {
      key: string,
      model: TModel,
      control: IAutoSave & AbstractControl
    }
  )
  {
    this.type = updateModelType(module, parentType, modelType);
  }
}





// WEBPACK FOOTER //
// ./src/app/pillar/workspace/store/actions/UpdateModelAction.ts